module.exports = __webpack_public_path__ + "fonts/MillerBanner-Light.937fbab2a5154dd58ef47a06f3472bde.woff";